import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "サイトコントローラーの設定方法",
		url: "https://chillnn.notion.site/80557def38df42f994e033e89ccde8cf?source=copy_link",
	},
];
